import React from "react"
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { Flex } from 'reflexbox'
import { Checkbox } from 'react-toolbox/lib/checkbox'
import CSSModules from 'helpers/CSSModulesUtil'
import Pie from 'components/custom/Highcharts/Pie'
import Bar from 'components/custom/Highcharts/Bar'

import {
  updateAeRegionsQueryAction
} from '../actions'
import {
  regionsEnum
} from '../constants'
import {
  aeRegionsQuerySelector,
} from '../selectors'
import styles from '../styles.scss'

const mapStateToProps = (state) => {
  return {
    aeRegionsQuery: aeRegionsQuerySelector(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateAeRegionsQuery: (regions) => dispatch(updateAeRegionsQueryAction(regions))
  }
}

class AeRegionsChart extends React.Component {
  render() {
    const {
      report,
      aeRegionsQuery,
      updateAeRegionsQuery
    } = this.props

    const handleChange = (field, isChecked) => {
      let newQuery = [...aeRegionsQuery]
      if (isChecked) {
        newQuery.push(field)
      } else {
        const index = newQuery.findIndex(region => region === field)
        newQuery.splice(index, 1)
      }
      updateAeRegionsQuery(newQuery)
    }

    return (
      <div>
        <div styleName='rowCharts'>
          {report.regionCharts.map((chart, index) =>
            <div styleName='regionChart' key={index}>
              <Pie
                title={report.regionsTitle}
                data={chart.data}
                additionalOptions={
                  {
                    subtitle: {
                      text: chart.region
                    }
                  }
                }
              />
            </div>
          )}
        </div>
        <Bar
          title={report.aeProjectAssignmentTitle}
          data={report.aeProjectAssignmentData}
          categories={report.aeUserCategories}
        />
        <Flex row='true' wrap>
          {Object.values(regionsEnum).map((region) => (
            <Checkbox
              styleName='checkboxes'
              key={region.label}
              label={region.label}
              checked={aeRegionsQuery.includes(region.value)}
              onChange={handleChange.bind(this, region.value)}
            />
          ))}
        </Flex>
      </div>
    );
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withStyle = CSSModules(styles)

export default compose(
  withConnect,
  withStyle
)(AeRegionsChart)
